"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _immutable = require("immutable");
var _createReducer = _interopRequireDefault(require("./createReducer.js"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
//
// StateHelper.js
//
// StateHelper is used to assist in the creation and usage of slices of state where
// the state is mean to represent a collection of ActiveRecord models.
//
// Updater functions are pure functions that perform common state mutations. They take
// a state object as their first parameter and return a new state object. These can be used
// to DRY up common functionality such as setting and updating records.
//
var StateHelper = /*#__PURE__*/function () {
  function StateHelper(Factory) {
    var _this = this;
    var expiration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 60 * 60 * 24;
    _classCallCheck(this, StateHelper);
    this.reset = function () {
      return _this.initialState;
    };
    this.resetAndSet = function (_state, payload) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return _this.set(_this.initialState, payload, options);
    };
    this.set = function (state, payload) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return _this.setRecords(state, _this.getRecordsFromPayload(payload), options);
    };
    this.update = function (state, payload) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var newState = state;
      _this.getRecordsFromPayload(payload).forEach(function (record) {
        var id = parseInt(record.id);
        if (state.has(id)) newState = _this.setRecord(newState, record, options);
      });
      return newState;
    };
    if (!Factory) throw new Error('Factory is required to instantiate a StateHelper');
    this.Factory = Factory;
    // TODO: Implement automatic record expiration
    this.expiration = expiration;
  }

  // If your state requires additional root-level attributes then you must extend StateHelper
  // and override `get initialState()`. Your overridden function should first call
  // StateHelper.initialState and then add the new attributes to it. (always use super method)
  _createClass(StateHelper, [{
    key: "initialState",
    get: function get() {
      return new _immutable.Map();
    }

    // State Updater Functions
    // These functions take a state object as the first parameter and return a new state object.
  }, {
    key: "setRecord",
    value: function setRecord(state, jsonRecord) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var newRecord;
      var oldRecord = state.get(parseInt(jsonRecord.id));
      if (oldRecord) {
        newRecord = this.Factory.update(oldRecord, jsonRecord, options);
      } else {
        newRecord = new this.Factory(jsonRecord, options);
      }
      return state.set(parseInt(jsonRecord.id), newRecord);
    }
  }, {
    key: "setRecords",
    value: function setRecords(state, jsonRecords) {
      var _this2 = this;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return jsonRecords.filter(function (record) {
        return record.type === _this2.Factory.jsonType;
      }).reduce(function (accumulator, jsonRecord) {
        return _this2.setRecord(accumulator, jsonRecord, options);
      }, state);
    }
  }, {
    key: "destroyRecord",
    value: function destroyRecord(state, id) {
      return state.delete(id);
    }
  }, {
    key: "getRecordsFromPayload",
    value: function getRecordsFromPayload(payload) {
      var _this3 = this;
      var records = [];
      if (Array.isArray(payload.data)) {
        records.push.apply(records, _toConsumableArray(payload.data.filter(function (record) {
          return record.type === _this3.Factory.jsonType;
        })));
      } else if (payload.data && payload.data.type === this.Factory.jsonType) {
        records.push(payload.data);
      }
      if (Array.isArray(payload.included)) {
        records.push.apply(records, _toConsumableArray(payload.included.filter(function (record) {
          return record.type === _this3.Factory.jsonType;
        })));
      }
      return records;
    }

    // Returns initialState with all records set from payload

    // Sets all records from payload

    // Only updates records which are already in the state

    // Reducer generator
    // Export the results of calling this function from your reducers instead of exporting the results
    // of the regular createReducer helper directly. This automatically passes in the expected arguments
    // for this StateHelper.
  }, {
    key: "createReducer",
    value: function createReducer(reducers) {
      return (0, _createReducer.default)(reducers, this.initialState);
    }
  }]);
  return StateHelper;
}();
exports.default = StateHelper;